// @ts-nocheck
import type { Question } from '../types';

export const priorityRulesQuestions: Question[] = [
  {
    id: 'q-priority-1',
    topic: 'General',
    question: 'You are approaching a junction where a tram is also approaching from your right. There are no signs or signals. Who has priority?',
    options: [
      { id: 'q-priority-1o1', text: 'You have priority because you are on the main road' },
      { id: 'q-priority-1o2', text: 'The tram has priority — you must give way' },
      { id: 'q-priority-1o3', text: 'Priority to the right applies — compare positions' },
    ],
    answerId: 'q-priority-1o2',
    explanation: 'Trams always have priority over other road users (RVV 1990 art. 3), regardless of direction. You must give way to the tram even if it is approaching from your right.',
    subject: 'Priority Rules',
  },
  {
    id: 'q-priority-2',
    questionType: 'hotspot',
    imageUrl: 'https://mllxuvubthdkdpsiiurr.supabase.co/storage/v1/object/public/cbr-videos/images/priority-rules/q-priority-2.jpg',
    topic: 'General',
    question: 'You are turning left at a junction. Who must you give way to?',
    options: [
      { id: 'q-priority-2o1', text: 'Oncoming traffic going straight or turning right, and cyclists and pedestrians crossing your path' },
      { id: 'q-priority-2o2', text: 'Only pedestrians crossing the road you are turning into' },
      { id: 'q-priority-2o3', text: 'No one — turning left gives you priority over oncoming traffic' },
    ],
    answerId: 'q-priority-2o1',
    explanation: 'When turning left you must give way to oncoming traffic going straight or turning right, and to cyclists and pedestrians crossing the road you are turning into.',
    subject: 'Priority Rules',
  },
  {
    id: 'q-priority-3',
    animationId: 'priority-anim-1',
    topic: 'General',
    question: 'You arrive at an unmarked 4-way crossroads at the same time as a car approaching from your right. No signs are present. Who has priority?',
    options: [
      { id: 'q-priority-3o1', text: 'The vehicle approaching from the right' },
      { id: 'q-priority-3o2', text: 'The larger vehicle' },
      { id: 'q-priority-3o3', text: 'The vehicle going straight ahead' },
    ],
    answerId: 'q-priority-3o1',
    explanation: 'At an unmarked junction, rechts heeft voorrang — the vehicle on your right has priority. You must give way to the car approaching from your right.',
    subject: 'Priority Rules',
  },
  {
    id: 'q-priority-4',
    questionType: 'hotspot',
    imageUrl: 'https://mllxuvubthdkdpsiiurr.supabase.co/storage/v1/object/public/cbr-videos/images/priority-rules/q-priority-4.jpg',
    topic: 'General',
    question: 'You see a "Voorrang verlenen" sign (inverted white triangle with red border) ahead. What does this require?',
    options: [
      { id: 'q-priority-4o1', text: 'Stop completely before proceeding' },
      { id: 'q-priority-4o2', text: 'Slow down and give way to traffic on the priority road' },
      { id: 'q-priority-4o3', text: 'Continue — you have priority over joining traffic' },
    ],
    answerId: 'q-priority-4o2',
    explanation: 'The Give Way sign means slow down and be prepared to stop if necessary to give way to traffic on the priority road. Unlike a Stop sign, you do not have to stop if the way is already clear.',
    subject: 'Priority Rules',
  },
  {
    id: 'q-priority-5',
    animationId: 'priority-anim-2',
    topic: 'General',
    question: 'You are on a through road approaching a T-junction. A vehicle is waiting to join from the side road on the right. Who has priority?',
    options: [
      { id: 'q-priority-5o1', text: 'You — vehicles on the through road have priority' },
      { id: 'q-priority-5o2', text: 'The vehicle joining from the side road' },
      { id: 'q-priority-5o3', text: 'Priority to the right applies — give way to them' },
    ],
    answerId: 'q-priority-5o1',
    explanation: 'At a T-junction, vehicles on the through road have priority. The vehicle at the side road must give way unless signs indicate otherwise.',
    subject: 'Priority Rules',
  },
  {
    id: 'q-priority-6',
    questionType: 'hotspot',
    imageUrl: 'https://mllxuvubthdkdpsiiurr.supabase.co/storage/v1/object/public/cbr-videos/images/priority-rules/q-priority-6.jpg',
    topic: 'General',
    question: 'An emergency vehicle with flashing blue lights and siren is approaching in front of you. What must you do?',
    options: [
      { id: 'q-priority-6o1', text: 'Maintain your speed and let it pass' },
      { id: 'q-priority-6o2', text: 'Give way immediately and create a clear path where safe' },
      { id: 'q-priority-6o3', text: 'Emergency vehicles only have priority at traffic lights' },
    ],
    answerId: 'q-priority-6o2',
    explanation: 'Emergency vehicles with blue lights and siren have absolute priority regardless of direction (RVV 1990 art. 91). Give way immediately by moving aside where safe, without endangering others.',
    subject: 'Priority Rules',
  },
  {
    id: 'q-priority-7',
    animationId: 'priority-anim-5',
    topic: 'General',
    question: 'You want to enter a roundabout. A car is already circulating on it. What must you do?',
    options: [
      { id: 'q-priority-7o1', text: 'Enter immediately — entering traffic has priority at Dutch roundabouts' },
      { id: 'q-priority-7o2', text: 'Give way to the circulating car — it has priority' },
      { id: 'q-priority-7o3', text: 'Priority to the right applies — compare positions' },
    ],
    answerId: 'q-priority-7o2',
    explanation: 'In the Netherlands, vehicles already on the roundabout have priority. Haaientanden (shark-teeth markings) at the entry confirm you must give way. Enter only when the roundabout is clear.',
    subject: 'Priority Rules',
  },
  {
    id: 'q-priority-8',
    questionType: 'hotspot',
    imageUrl: 'https://mllxuvubthdkdpsiiurr.supabase.co/storage/v1/object/public/cbr-videos/images/priority-rules/q-priority-8.jpg',
    topic: 'General',
    question: 'You approach a junction with a STOP sign (B7). You have stopped at the stop line. When may you proceed?',
    options: [
      { id: 'q-priority-8o1', text: 'Immediately after stopping, if no vehicles are visible' },
      { id: 'q-priority-8o2', text: 'Only when you have given way to all traffic on the priority road' },
      { id: 'q-priority-8o3', text: 'As soon as the way appears clear from left and right' },
    ],
    answerId: 'q-priority-8o2',
    explanation: 'A STOP sign requires you to stop completely and give way to all traffic on the priority road before proceeding. Stopping is mandatory regardless of whether traffic is visible.',
    subject: 'Priority Rules',
  },
  {
    id: 'q-priority-10',
    questionType: 'hotspot',
    imageUrl: 'https://mllxuvubthdkdpsiiurr.supabase.co/storage/v1/object/public/cbr-videos/images/priority-rules/q-priority-10.jpg',
    topic: 'General',
    question: 'You see a yellow diamond sign with a white border on your road. What does this mean at the next junction?',
    options: [
      { id: 'q-priority-10o1', text: 'You must give way to traffic from other directions' },
      { id: 'q-priority-10o2', text: 'A roundabout is ahead' },
      { id: 'q-priority-10o3', text: 'You have priority over traffic joining from side roads' },
    ],
    answerId: 'q-priority-10o3',
    explanation: 'The yellow diamond sign (voorrangsweg) means you are on a priority road. Traffic joining from side roads must give way to you at junctions ahead.',
    subject: 'Priority Rules',
  },
  {
    id: 'q-priority2-1',
    topic: 'General',
    question: 'You are on a priority road approaching a junction. You then see a "Voorrang verlenen" (Give way) sign. What does this mean?',
    options: [
      { id: 'q-priority2-1o1', text: 'You still have priority until you leave the junction' },
      { id: 'q-priority2-1o2', text: 'Your priority road has ended — give way to traffic on the road you are joining' },
      { id: 'q-priority2-1o3', text: 'Priority to the right applies only from this point' },
    ],
    answerId: 'q-priority2-1o2',
    explanation: 'When your priority road ends, the Give Way sign means you must yield to traffic on the road you are joining. Your voorrangsweg status ends at this junction.',
    subject: 'Priority Rules',
  },
  {
    id: 'q-priority2-2',
    animationId: 'priority-anim-3',
    topic: 'General',
    question: 'You are turning right at a junction. A cyclist is going straight ahead on the fietspad crossing your path. Who has priority?',
    options: [
      { id: 'q-priority2-2o1', text: 'You have priority when turning right' },
      { id: 'q-priority2-2o2', text: 'The cyclist going straight has priority — you must give way' },
      { id: 'q-priority2-2o3', text: 'Whoever reaches the crossing first' },
    ],
    answerId: 'q-priority2-2o2',
    explanation: 'When turning right, you must give way to cyclists going straight on the fietspad crossing your path. Turning drivers must always yield to through traffic and cyclists.',
    subject: 'Priority Rules',
  },
  {
    id: 'q-priority2-3',
    animationId: 'priority-anim-1',
    topic: 'General',
    question: 'At an unmarked junction, you and another vehicle arrive at the same time. The other vehicle is on your right. What should you do?',
    options: [
      { id: 'q-priority2-3o1', text: 'Proceed — you have priority as you are going straight' },
      { id: 'q-priority2-3o2', text: 'Give way to the vehicle on your right' },
      { id: 'q-priority2-3o3', text: 'Sound your horn and proceed cautiously' },
    ],
    answerId: 'q-priority2-3o2',
    explanation: 'At an unmarked junction, rechts heeft voorrang. You must give way to any vehicle approaching from your right, regardless of direction of travel.',
    subject: 'Priority Rules',
  },
  {
    id: 'q-priority2-4',
    topic: 'General',
    question: 'A tram is approaching from your left at a junction. There are no signs or road markings. Who has priority?',
    options: [
      { id: 'q-priority2-4o1', text: 'You have priority — trams give way to the right' },
      { id: 'q-priority2-4o2', text: 'The tram has priority — you must give way regardless of direction' },
      { id: 'q-priority2-4o3', text: 'Priority to the right applies — you are on the right so you go first' },
    ],
    answerId: 'q-priority2-4o2',
    explanation: 'Trams always have priority over other road users — including when approaching from the left. The rechts heeft voorrang rule does not apply to trams. (RVV 1990 art. 3)',
    subject: 'Priority Rules',
  },
  {
    id: 'q-priority2-5',
    questionType: 'hotspot',
    imageUrl: 'https://mllxuvubthdkdpsiiurr.supabase.co/storage/v1/object/public/cbr-videos/images/priority-rules/q-priority2-5.jpg',
    topic: 'General',
    question: 'You are leaving a private driveway to join a road. Who has priority?',
    options: [
      { id: 'q-priority2-5o1', text: 'You have priority when joining' },
      { id: 'q-priority2-5o2', text: 'All road traffic and pedestrians have priority — you must give way' },
      { id: 'q-priority2-5o3', text: 'Only pedestrians; then you may join when clear' },
    ],
    answerId: 'q-priority2-5o2',
    explanation: 'When joining a road from a driveway or private access, you must give way to all traffic and pedestrians on that road. (RVV 1990 art. 54)',
    subject: 'Priority Rules',
  },
  {
    id: 'q-priority2-7',
    questionType: 'hotspot',
    imageUrl: 'https://mllxuvubthdkdpsiiurr.supabase.co/storage/v1/object/public/cbr-videos/images/priority-rules/q-priority2-7.jpg',
    topic: 'General',
    question: 'You approach a junction with a STOP sign (B7). You have stopped. When may you proceed?',
    options: [
      { id: 'q-priority2-7o1', text: 'As soon as you have come to a complete stop' },
      { id: 'q-priority2-7o2', text: 'When you can do so without affecting priority traffic on the other road' },
      { id: 'q-priority2-7o3', text: 'When no vehicles are visible in either direction' },
    ],
    answerId: 'q-priority2-7o2',
    explanation: 'After stopping at a STOP sign, you may proceed only when you can do so safely without affecting traffic on the priority road. Visibility alone is not enough — you must be certain you will not obstruct priority traffic.',
    subject: 'Priority Rules',
  },
  {
    id: 'q-priority2-8',
    topic: 'General',
    question: 'You are turning left into a side road. A pedestrian is crossing that side road ahead. Who has priority?',
    options: [
      { id: 'q-priority2-8o1', text: 'You have priority — the pedestrian must wait' },
      { id: 'q-priority2-8o2', text: 'The pedestrian has priority — you must give way' },
      { id: 'q-priority2-8o3', text: 'Whoever reaches the crossing first' },
    ],
    answerId: 'q-priority2-8o2',
    explanation: 'When turning into a side road, you must give way to pedestrians who are crossing or about to cross that road (RVV art. 49). Pedestrians always have priority over turning vehicles.',
    subject: 'Priority Rules',
  },
  {
    id: 'q-priority2-9',
    topic: 'General',
    question: 'You arrive at an unmarked junction of two equal roads. No vehicle is approaching from your right. May you proceed?',
    options: [
      { id: 'q-priority2-9o1', text: 'Yes, always — you always have priority at this junction' },
      { id: 'q-priority2-9o2', text: 'Yes, but only when you are sure no vehicle is approaching from your right' },
      { id: 'q-priority2-9o3', text: 'No — you must always stop at an unmarked junction first' },
    ],
    answerId: 'q-priority2-9o2',
    explanation: 'At an unmarked junction you may proceed when no vehicle is approaching from your right. Always check carefully before entering — the right-of-way rule means you must yield if a vehicle appears on your right.',
    subject: 'Priority Rules',
  },
  {
    id: 'q-priority2-10',
    topic: 'General',
    question: 'You are driving in a built-up area. A bus at a marked bus stop on your right has its indicator on and is about to pull out. What must you do?',
    options: [
      { id: 'q-priority2-10o1', text: 'Maintain your speed — you have priority on the road' },
      { id: 'q-priority2-10o2', text: 'Give way to the bus — it has priority when signalling to leave a bus stop within a built-up area' },
      { id: 'q-priority2-10o3', text: 'Sound your horn to alert the bus driver you are there' },
    ],
    answerId: 'q-priority2-10o2',
    explanation: 'Within a built-up area (bebouwde kom), you must give way to buses leaving a marked bus stop when they signal (RVV 1990 art. 50). Slow down and let the bus out safely.',
    subject: 'Priority Rules',
  },
  {
    id: 'q-priority2-11',
    questionType: 'hotspot',
    imageUrl: 'https://mllxuvubthdkdpsiiurr.supabase.co/storage/v1/object/public/cbr-videos/images/priority-rules/q-priority2-11.jpg',
    topic: 'General',
    question: 'You are on a road with a yellow diamond (voorrangsweg) sign. You then see a Give Way sign at a junction ahead. What do you do?',
    options: [
      { id: 'q-priority2-11o1', text: 'The diamond overrides the Give Way — you still have priority' },
      { id: 'q-priority2-11o2', text: 'The Give Way sign applies — yield to traffic on the road you are joining' },
      { id: 'q-priority2-11o3', text: 'Treat it as priority to the right only' },
    ],
    answerId: 'q-priority2-11o2',
    explanation: 'The Give Way sign at the junction overrides your voorrangsweg status. Your priority road has ended here and you must yield to traffic on the road you are joining.',
    subject: 'Priority Rules',
  },
  {
    id: 'q-priority2-12',
    questionType: 'hotspot',
    imageUrl: 'https://mllxuvubthdkdpsiiurr.supabase.co/storage/v1/object/public/cbr-videos/images/priority-rules/q-priority2-12.jpg',
    topic: 'General',
    question: 'You are turning right at a 4-way junction. What must you do before turning?',
    options: [
      { id: 'q-priority2-12o1', text: 'Turn immediately — you have priority when turning right' },
      { id: 'q-priority2-12o2', text: 'Check for pedestrians and cyclists crossing the road you are turning into, and give way if necessary' },
      { id: 'q-priority2-12o3', text: 'Sound your horn to alert other road users' },
    ],
    answerId: 'q-priority2-12o2',
    explanation: 'When turning right at any junction, you must give way to pedestrians crossing the road you are turning into and to cyclists on the fietspad (RVV 1990 art. 49). Always check that your turning path is clear before proceeding.',
    subject: 'Priority Rules',
  },
  {
    id: 'q-ped-tram-priority',
    imageUrl: 'https://mllxuvubthdkdpsiiurr.supabase.co/storage/v1/object/public/cbr-videos/images/priority-rules/priority-ped-tram.png',
    topic: 'General',
    question: 'A pedestrian and a tram arrive at a zebra crossing at the same time. In which order must they give way?',
    options: [
      { id: 'q-ped-tram-o1', text: '1, 2' },
      { id: 'q-ped-tram-o2', text: '2, 1' },
      { id: 'q-ped-tram-o3', text: 'At the same time' },
    ],
    answerId: 'q-ped-tram-o1',
    explanation: 'At a zebra crossing, pedestrians always have priority. The tram must give way to the pedestrian even though trams normally have priority over other road users (RVV 1990 art. 49). Pedestrian = 1, Tram = 2.',
    subject: 'Priority Rules',
  },
  {
    id: 'q-tram-car-priority',
    imageUrl: 'https://mllxuvubthdkdpsiiurr.supabase.co/storage/v1/object/public/cbr-videos/images/priority-rules/priority-tram-car.png',
    topic: 'General',
    question: 'A tram and a car approach the same junction. In which order must they give way?',
    options: [
      { id: 'q-tram-car-o1', text: '2, 1' },
      { id: 'q-tram-car-o2', text: '1, 2' },
      { id: 'q-tram-car-o3', text: 'At the same time' },
    ],
    answerId: 'q-tram-car-o2',
    explanation: 'Trams always have priority over all other road users (RVV 1990 art. 3). The car must give way to the tram regardless of any road markings or signs. Tram = 1, Car = 2.',
    subject: 'Priority Rules',
  },
  {
    id: 'q-emergency-tram-car',
    imageUrl: 'https://mllxuvubthdkdpsiiurr.supabase.co/storage/v1/object/public/cbr-videos/images/priority-rules/priority-emergency-tram-car.png',
    topic: 'General',
    question: 'An emergency vehicle, a tram, and a car approach the same point. In which order must they give way?',
    options: [
      { id: 'q-emergency-tram-car-o1', text: '1, 2, 3' },
      { id: 'q-emergency-tram-car-o2', text: '2, 1, 3' },
      { id: 'q-emergency-tram-car-o3', text: '3, 2, 1' },
    ],
    answerId: 'q-emergency-tram-car-o1',
    explanation: 'Emergency vehicles with blue lights and sirens have absolute priority over all road users (RVV 1990 art. 91). Trams have priority over regular vehicles (art. 3). Therefore: Emergency vehicle = 1, Tram = 2, Car = 3.',
    subject: 'Priority Rules',
  },
];
